import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { TenantListPage } from '@/components/tenant-list-page'

export const Route = createFileRoute('/_app/tenants/past')({
	component: TenantPastPage,
})

function TenantPastPage() {
	const { t } = useTranslation()
	return (
		<TenantListPage
			period="past"
			emptyTitle={t('tenants.past.emptyTitle')}
			emptyDescription={t('tenants.past.emptyDescription')}
		/>
	)
}
